import React, { useEffect, useState } from "react";
import { getStoredData } from "../../json/fetchData";
import AllCompanyIntro from "../../components/AllCompanyIntro/AllCompanyIntro";
import AllCompanyClient from "../../components/AllCompanyClient/AllCompanyclient";
import Contact from "../../components/Contact/Contact";
import AllcompanyCarousel from "../../components/AllCompanyCarousel/AllcompanyCarousel";
import HeroSection from "../../components/Herosection/Herosection";
import Loader from "../../components/Loader/Loader";
import BulletSection from "../../components/BulletSection/BulletSection";

export const Home = () => {
  const [data, setData] = useState(null);
  const [allLoaded, setAllLoaded] = useState(false);

  useEffect(() => {
    const stored = getStoredData();
    setData(stored);
  }, []);

  useEffect(() => {
    if (!data) return;

    const Data = data["1"];
    let assetsToLoad = 0;
    let assetsLoaded = 0;

    // Track all images used in the components
    const imagesToTrack = [
      Data.CompanyIntroImage,
      Data.Projectimage,
      Data.ServicesImage,
      Data.ContactImage,
      ...(Data.Testimonialslides?.map(s => s.image) || [])
    ].filter(Boolean);

    assetsToLoad = imagesToTrack.length;

    if (assetsToLoad === 0) {
      setAllLoaded(true);
      return;
    }

    imagesToTrack.forEach((url) => {
      const img = new Image();
      img.src = url;
      img.onload = img.onerror = () => {
        assetsLoaded += 1;
        if (assetsLoaded === assetsToLoad) {
          setAllLoaded(true);
        }
      };
    });
  }, [data]);

  if (!data || !allLoaded) return <Loader />;

  const Data = data["1"];

  return (
    <div>
      <HeroSection api={Data.heroapi}/>
      <AllCompanyIntro
        title={Data.CompanyIntroTitle}
        established={Data.CompanyIntroEstablished}
        description={Data.CompanyIntroDescription}
        image={Data.CompanyIntroImage}
        buttonText={Data.CompanyIntroButtonText}
        link={Data.CompanyIntroLink}
        iconButton={Data.CompanyIntroIconButton}
      />

      <BulletSection
        title={Data.Projecttitle}
        heading={Data.Projectheading}
        image={Data.Projectimage}
        services={Data.Projectservices}
        button={Data.ProjectbuttonText}
        link={Data.ProjectButtonLink}
      />

      <BulletSection
        title={Data.Servicestitle}
        heading={Data.Servicesheading}
        image={Data.ServicesImage}
        services={Data.Servicesservices}
        button={Data.ServicesbuttonText}
        link={Data.ServicesButtonLink}
        reverse={true}
      />

      <AllCompanyClient clients={Data.Client} title={Data.ClientTitle} />
      <Contact
        title={Data.Formtitle}
        fields={Data.Formfields}
        button={Data.FormbuttonText}
        image={Data.ContactImage}
      />
      <AllcompanyCarousel slides={Data.Testimonialslides} />
    </div>
  );
};
